import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerInputClass;
function DeletePlayerInput() {
  if (DeletePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId) {
        this.v6s_1 = partyId;
        this.w6s_1 = playerId;
      }
      toString() {
        return 'DeletePlayerInput(partyId=' + this.v6s_1.toString() + ', playerId=' + this.w6s_1.toString() + ')';
      }
      hashCode() {
        var result = this.v6s_1.hashCode();
        result = imul(result, 31) + this.w6s_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePlayerInput()))
          return false;
        if (!this.v6s_1.equals(other.v6s_1))
          return false;
        if (!this.w6s_1.equals(other.w6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePlayerInput');
    DeletePlayerInputClass = $;
  }
  return DeletePlayerInputClass;
}
//region block: exports
export {
  DeletePlayerInput as DeletePlayerInput3nqh5he11jo1p,
};
//endregion

//# sourceMappingURL=DeletePlayerInput.mjs.map
